// Dahabshiil Bank masked account mappings
// Add new accounts here when a new Dahabshiil account is created for a project
// id = project_id from the database
export const dahabshiil_accounts = [
  { projectId: 2281, accountNumber: "BORD8151", maskedAccount: "08151" },
];

// Helper function to get masked account by project ID
export const getMaskedAccount = (projectId) => {
  const account = dahabshiil_accounts.find(
    (acc) => acc.projectId === projectId,
  );
  return account?.maskedAccount || null;
};
